export default __webpack_public_path__ + "static/media/1819 knife block A side.a9b916ad.png";